// What an address nobody declared answers. The route table ends with this under
// the guard, so the reader is sent where every refused address sends them: their
// own Acasă, with the guard's «Nu ai acces…» notice. There is no not-found page
// for a signed-in reader (owner decision Q-1-07); an anonymous one never gets
// this far, the guard having sent them to the public home page first.
// per docs/shape-ops-route-authorisation.md §Unknown addresses
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../../hooks/use-session';
import { homePathFor } from '../role-home';

export function UnknownAddress(): JSX.Element {
  const location = useLocation();
  const { data: session } = useSession();
  const home = homePathFor(session?.activeRole ?? '');
  return <Navigate to={home} replace state={{ deniedFrom: location.pathname }} />;
}
